module.exports = __webpack_public_path__ + "img/scorecard-7.62e5e03c.jpg";